import { MerchantCenterViewer } from "../assessmentViewer/FoundationStage";
import styles from "./GoogleMerchantCenterViewer.module.css";

const pickMerchantCenterText = (data = {}) => {
  const section = data?.merchant_center_trust_checklist;
  if (typeof section === "string") return section.trim();
  if (section && typeof section === "object" && typeof section.text === "string") {
    return section.text.trim();
  }
  return "";
};

const GoogleMerchantCenterViewer = ({ data = {} }) => {
  const markdown = pickMerchantCenterText(data);
  const summary =
    typeof data?.summary === "string"
      ? data.summary.trim()
      : "";

  if (!markdown && !summary) return null;

  return (
    <div className={styles.container}>
      {summary ? (
        <div className={styles.summaryCard}>
          <p className={styles.summaryLabel}>Report Summary</p>
          <p className={styles.summaryText}>{summary}</p>
        </div>
      ) : null}
      {markdown ? <MerchantCenterViewer markdown={markdown} /> : null}
    </div>
  );
};

export default GoogleMerchantCenterViewer;
